// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"30":"29c29c31","953":"1b1a422b"}[chunkId] + ".chunk.css";
};